/* eslint-disable react-refresh/only-export-components */

import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { parseAppModeFromPathAndSearch, type AppModeState } from '@/lib/appMode';

const AppModeContext = createContext<AppModeState | null>(null);

export function AppModeProvider({ children }: { children: ReactNode }) {
  const location = useLocation();

  const value = useMemo(
    () => parseAppModeFromPathAndSearch(location.pathname, location.search),
    [location.pathname, location.search]
  );

  return <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>;
}

export function useAppMode(): AppModeState {
  const ctx = useContext(AppModeContext);
  if (!ctx) {
    // Safe default: treat as standalone to avoid business leakage.
    return { mode: 'standalone', source: 'none', restaurant: null };
  }
  return ctx;
}
